// extracted by mini-css-extract-plugin
export var button = "cart-button-module--button--zd1za";
export var circle = "cart-button-module--circle--2hqvP";
export var disabledLike = "cart-button-module--disabled-like--cIK21";
export var fullButton = "cart-button-module--full-button--+drC9";
export var icon = "cart-button-module--icon--yoU9A";
export var iconBox = "cart-button-module--icon-box--9m8IH";
export var normalButton = "cart-button-module--normal-button--mrqQA";
export var text = "cart-button-module--text--HE7ne";
export var transitionButton = "cart-button-module--transition-button--DZQQk";